export default class RelationsApi {
  constructor(client) {
    this.client = client
  }

  customersRelated(hash, params) {
    return this.client.get(`admin/v1/professionals/${hash}/related`, { params }).then((response) => response.data)
  }

  customersNoRelated(hash, params) {
    return this.client.get(`admin/v1/professionals/${hash}/unrelated`, { params }).then((response) => response.data)
  }

  setRelation(hash, params) {
    return this.client.post(`admin/v1/professionals/${hash}/relationships`, params).then((response) => response.data)
  }
  revokeRelation(hash, params) {
    return this.client
      .delete(`admin/v1/professionals/${hash}/relationships`, { params })
      .then((response) => response.data)
  }
}
